import { render } from "./DevfolioComponent.vue?vue&type=template&id=7476ac36"
import script from "./DevfolioComponent.vue?vue&type=script&lang=js"
export * from "./DevfolioComponent.vue?vue&type=script&lang=js"

import "./DevfolioComponent.vue?vue&type=style&index=0&id=7476ac36&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__